import { Navigate } from "react-router-dom";
import type { ReactNode } from "react";

import { useAuth } from "./AuthProvider";

interface Props {
  groups: ReadonlyArray<"SuperAdmin" | "Admin" | "Worker">;
  children: ReactNode;
}

/** Hard role guard. Use for SuperAdmin-only sections etc. */
export function RequireGroup({ groups, children }: Props) {
  const { me } = useAuth();
  if (!me) return <Navigate to="/login" replace />;
  if (!groups.includes(me.group_name as (typeof groups)[number])) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
